<script setup lang="ts">

const props = withDefaults(
    defineProps<{
        title?: string
        count?: number | null
    }>(),
    {
        title: 'Results',
        count: null,
    }
)
</script>

<template>
    <div class="table-header">
        <slot name="tableHeader">
            <div class="table-header__left">
                <slot name="tableHeaderLeft">
                    <div class="table-header__title">
                        <slot name="tableHeaderTitle">
                            {{ props.title }}
                        </slot>
                    </div>
                    <div v-if="props.count !== null" class="table-header__count">
                        <slot name="tableHeaderCount">
                            {{ props.count }}
                        </slot>
                    </div>
                </slot>
            </div>
            <div class="table-header__right">
                <slot name="tableHeaderRight" />
            </div>
        </slot>
    </div>
</template>

<style lang="scss" scoped>

.table-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 4px 16px;

    &__left {
        display: flex;
        font-weight: 600;
        font-size: 14px;
        line-height: 19px;
    }

    &__title {
        margin-right: 6px;
    }

    &__count {
        color: $slate;
    }
}
</style>
